import { CSSProperties } from "react";
import "./serviceGraphics.css";

const Tick = () => (
  <svg viewBox="0 0 16 16">
    <path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const STAGES = ["BOOKED", "IN BAY", "PARTS", "READY", "DONE"];

/** One work order; `at` = index of its current stage in STAGES. */
const ORDERS = [
  { id: "WO-2318", car: "2019 Honda Civic", job: "Brakes", at: 2, state: "Waiting on parts", wait: true },
  { id: "WO-2317", car: "2022 Ford F-150", job: "Oil change", at: 3, state: "Ready for pickup" },
  { id: "WO-2316", car: "2020 Mazda CX-5", job: "Diagnostics", at: 1, state: "In bay 2" },
  { id: "WO-2315", car: "2018 Toyota Corolla", job: "Tires", at: 4, state: "Picked up" },
];

const PARTS = [
  { name: "Brake pads (front)", level: 15, note: "4 left · reorder", low: true },
  { name: "Oil filter", level: 70, note: "28 in stock" },
  { name: "Wiper blades", level: 45, note: "12 in stock" },
];

const pct = (value: number) => ({ ["--gfx-p" as string]: `${value}%` } as CSSProperties);

/**
 * Illustration of a garage admin panel (Work page: JVM Auto): work orders
 * moving along their own route line, and a parts inventory with a low-stock
 * flag. Drawn in our style with generic example data — not the client's UI.
 */
const AdminPanelGraphic = () => (
  <div className="is-gfx gfx--admin" aria-hidden="true">
    <div className="gfx-win">
      <div className="gfx-bar">
        <div className="gfx-lights">
          <i />
          <i />
          <i />
        </div>
        <span className="gfx-title">admin / work orders</span>
      </div>
      <div className="gfx-admin">
        <div className="gfx-admin__side">
          <b>Garage admin</b>
          <span>Dashboard</span>
          <span className="on">Work orders</span>
          <span>Parts</span>
          <span>Customers</span>
          <span>Invoices</span>
        </div>
        <div className="gfx-admin__main">
          <div className="gfx-admin__head">
            <b>Work orders</b>
            <small>TODAY · 4 OPEN</small>
            <span className="gfx-admin__new">+ New order</span>
          </div>
          <div className="gfx-wo-table">
            <div className="gfx-wo-row gfx-wo-row--legend">
              <span>ORDER</span>
              <span className="gfx-wo-legend">
                {STAGES.map((s) => (
                  <span key={s}>{s}</span>
                ))}
              </span>
              <span />
            </div>
            {ORDERS.map((o) => (
              <div key={o.id} className="gfx-wo-row">
                <span>
                  <b>{o.id}</b>
                  <small>
                    {o.car} · {o.job}
                  </small>
                </span>
                <span className="gfx-wo-route" style={pct((o.at / (STAGES.length - 1)) * 96)}>
                  {STAGES.map((s, i) => (
                    <i key={s} className={i < o.at ? "done" : i === o.at ? "now" : undefined} />
                  ))}
                </span>
                <span className={"gfx-wo-state" + (o.wait ? " gfx-wo-state--wait" : "")}>{o.state}</span>
              </div>
            ))}
          </div>
          <div className="gfx-parts">
            <div className="gfx-parts__head">
              Parts<span>INVENTORY</span>
            </div>
            {PARTS.map((p) => (
              <div key={p.name} className={"gfx-part" + (p.low ? " gfx-part--low" : "")}>
                <span>{p.name}</span>
                <span className="gfx-part__bar">
                  <i style={pct(p.level)} />
                </span>
                <em>{p.note}</em>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    <div className="gfx-chip gfx-reserve">
      <span className="gfx-check">
        <Tick />
      </span>
      <span>
        <b>2 × brake pads reserved</b>
        <span>for WO-2318 · supplier order placed</span>
      </span>
    </div>
  </div>
);

export default AdminPanelGraphic;
